import React from 'react';
import { Container, Image, Segment, Button} from 'semantic-ui-react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";

import { Explore } from './components/home/Explore';
import { PageTitle } from './components/common/PageTitle';
import { NavBar } from './components/common/NavBar';
import { Footer } from './components/common/Footer';
// import { PrivateRoute } from './components/common/PrivateRoute';

import { ViewComposer } from './components/views/ViewComposer';
import { ViewSongCycle } from './components/views/ViewSongCycle';
import { ViewSong } from './components/views/ViewSong';

import { EditSongVersion } from './components/views/EditSongVersion';

import { BrowseSongs } from './components/pages/BrowseSongs';
import { BrowseComposers } from './components/pages/BrowseComposers';
import { ContentAboutLSP } from './components/pages/ContentAboutLSP';
import { ContentPartnership } from './components/pages/ContentPartnership';
import { SearchResults } from './components/pages/SearchResults';
import { BrowseSongCycles } from './components/pages/BrowseSongCycles';
import {ProfilePage} from './components/pages/ProfilePage'
import { BrowseTextAuthors} from './components/pages/BrowseTextAuthors';
import { ViewTextAuthor } from './components/views/ViewTextAuthor';
import { FeedbackForm } from './components/pages/Feedback';
import { BrowseVocalChamberMusic } from './components/pages/BrowseVocalChamberMusic';





import './App.css';


function App() {
  const { isAuthenticated, loading} = useAuth0();


  if (loading) {
    return (
      <Container id="main" fluid>
        <Segment loading>
          <h1>Loading...</h1>
        </Segment>
      </Container>
    );
  }


  return (
    <Router>
      <Container id="main" fluid>  
        <NavBar />
        <Switch>
          <Route path='/partnership' component={ContentPartnership} />
          <Route path='/about' component={ContentAboutLSP} />
          <Route path='/composers/:id' component={ViewComposer} />
          <Route path='/song_cycles/:id' component={ViewSongCycle} />
          <Route path='/songs/:id' component={ViewSong} />
          <Route path='/song_versions/:id' component={EditSongVersion} />
          <Route path='/songs' component={BrowseSongs} />
          <Route path='/composers' component={BrowseComposers} />
          <Route path='/song-cycles' component={BrowseSongCycles} />
          <Route path='/chamber-music' component={BrowseVocalChamberMusic} />
          <Route path="/search" component={SearchResults} />
          <Route path="/profile" component={ProfilePage} />
	  <Route path='/text-authors' component={BrowseTextAuthors}/>
          <Route path="/text_authors/:id" component={ViewTextAuthor} />
          <Route path="/feedback" component={FeedbackForm} />
          <Route path="/">
            <PageTitle title='Coming Soon!' name='explore' bgImg='/img/living-song-project-background.png'>
              <p>We’d like to thank everyone who has supported this project.</p>
              <p>We're pleased to announce an exciting new partnership with NATS, who will be hosting our website.</p>
              <Image inline src='/img/nats-logo.png' className='nats-logo'/>
                {isAuthenticated && (
                <div
                  style={{
                    width: "40%",
                    minWidth: "300px",
                    margin: "30px auto",
                    padding: "20px",
                    backgroundColor: "white",
                    color: "black",
                    textAlign: "center",
                    borderRadius: "5px"
                  }}
                >
                  <p style={{ color: "black" }}>
                    We encourage any and all feedback as we improve our
                    site & its collections.
                  </p>

                  <Button
                    primary
                    onClick={() => window.location.href = "/feedback"}
                  >
                    Send Feedback
                  </Button>
                </div>
              )}
              
            </PageTitle>
            <Container id="explore" fluid>
              <Explore />
            </Container>
          </Route>          
        </Switch>
      </Container>
      <Footer />
    </Router>
  );
}

export default App;
